import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=7e8f23fd"
import script from "./LeftSideBar.vue?vue&type=script&lang=ts"
export * from "./LeftSideBar.vue?vue&type=script&lang=ts"
import style0 from "./LeftSideBar.vue?vue&type=style&index=0&id=7e8f23fd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports